// @flow

import isEmpty from 'lodash/isEmpty';
import { WORKSPACE_ROOT_FOLDER_ID } from './folders-constants';

export const getFoldersByParentId = (
  allFolders,
  parentId,
  includeSubFolders,
) => {
  if (!includeSubFolders) {
    if (parentId === -1) {
      return allFolders.filter((folder) => folder.parentId === null);
    }

    return (
      allFolders.filter((folder) => folder.parentId === parentId)
    );
  }

  if (parentId === -1) {
    return allFolders;
  }

  return (
    allFolders.filter((folder) => {
      const parentPath = folder.parentPath.split('/').slice(0, -1).map((path) => Number(path));
      return parentPath.includes(parentId);
    })
  );
};

export const folderNameAlreadyExists = (newFolderName, selectedFolderId, foldersArr) => {
  const parentFolderId = (selectedFolderId !== -1) ? selectedFolderId : null;
  const array = getFoldersByParentId(foldersArr, parentFolderId);

  return array.some((folder) => folder.name.toLowerCase() === newFolderName.toLowerCase());
};

export const generateDuplicateName = (name, selectedFolderId, foldersArr) => {
  if (!foldersArr.length) {
    return name;
  }

  let counter = 2;
  let newName;

  const reg = new RegExp('.*(?:\\D|^)(\\d+)');
  const matchNumber = name.match(reg);

  if (matchNumber) {
    const foundNumber = matchNumber[1];
    const indexFromEnd = matchNumber.index + foundNumber.length;
    const indexFromStart = name.length - indexFromEnd;
    counter = Number.parseInt(foundNumber, 10) + 1;

    newName = name.substring(0, indexFromStart) + counter;
  } else {
    newName = `${name} ${counter}`;
  }

  if (folderNameAlreadyExists(newName, selectedFolderId, foldersArr)) {
    newName = generateDuplicateName(newName, selectedFolderId, foldersArr);
  }

  return newName;
};

// When cleaning up remove isFolderV2, make sure that it keeps the same logic as when it is true
export const getRedirectPath = (
  location: any,
  destinationFolderId: number,
  isFolderV2: boolean,
) => {
  const folderIdsKey = 'folderIds[]';

  const searchParams = new URLSearchParams(location.search);

  searchParams.set(folderIdsKey, destinationFolderId);

  // TODO: Delete the whole if statement when folderV2 is release
  if (destinationFolderId === WORKSPACE_ROOT_FOLDER_ID && !isFolderV2) {
    searchParams.delete(folderIdsKey);
  }

  searchParams.delete('page');

  return searchParams.toString();
};

export const getRemoveRedirectPath = (location: any, id: number) => {
  const searchParams = location.search.split('&');
  searchParams[0] = searchParams[0].substring(1);
  const folderParam = searchParams.find((param) => param.includes('folderIds'));
  const folderParamIncludesId = folderParam?.includes(id.toString());

  if (folderParamIncludesId) {
    const folderParamIndex = searchParams.findIndex((param) => param.includes('folderIds'));
    searchParams.splice(folderParamIndex, 1);
  }

  return `?${searchParams.join('&')}`;
};

export const getSubFolders = (folders: Folder[], folderId: number): Folder[] => {
  if (!folderId || isEmpty(folders)) {
    return [];
  }
  return folders.filter((folder) => folder.parentId === folderId);
};
